import {Model} from '@vuex-orm/core'

export default class RoomtypesHasLtmsHasOperationmodesHasDevicepackageAt extends Model {
  static entity = 'roomtypesHasLtmsHasOperationmodesHasDevicepackageAt'

  static fields() {
    return {
      id: this.number(null),
      ltms_id: this.attr(null),
      roomltms_id: this.attr(null),
      roomtypes_has_operationmodes_has_airvolumes_id: this.attr(null),
      devicepackages_id: this.attr(null),
      device_optional: this.attr(null),
    }
  }
}
